"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderItem = void 0;

var _styles = require("./styles");

var _ColumnItem = require("./ColumnItem");

var _CheckBox = require("../../atoms/CheckBox");

var _jsxRuntime = require("react/jsx-runtime");

var HeaderItem = function HeaderItem(_ref) {
  var _ref$columnsArray = _ref.columnsArray,
      columnsArray = _ref$columnsArray === void 0 ? [] : _ref$columnsArray,
      checkAll = _ref.checkAll,
      chkCheckedAll = _ref.chkCheckedAll;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "chk-global-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
        id: "chk-global",
        name: "chk-global",
        onChange: function onChange(e) {
          return checkAll && checkAll(e);
        },
        checked: chkCheckedAll && chkCheckedAll()
      })
    }), columnsArray.map(function (col, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColumnItem.ColumnItem, {
        flex: col.flex,
        name: col.name,
        minWidth: col.minWidth
      }, i);
    })]
  });
};

exports.HeaderItem = HeaderItem;